import React from "react"
import { AppEHR, EHRRecord } from "../../store/types";


interface EHRManagerProps {
    knownEHRs: EHRRecord[]
    appEHRs: AppEHR[],
    onChange: (ehrs: AppEHR[]) => void
}

interface EHRManagerState {
    [key:string]: string
}

export default class EHRManager extends React.Component<EHRManagerProps>
{
    urls: EHRManagerState = {}

    sync()
    {
        this.props.knownEHRs.forEach(ehr => {
            const appEhr = this.props.appEHRs.find(x => x.ehr_id === ehr.id);
            const url = appEhr ? appEhr.url || "" : "";
            if (url) {
                this.urls[ehr.id + ""] = url;
            }
        });
    }

    render()
    {
        const { knownEHRs, appEHRs, onChange } = this.props;
        this.sync();
        return (
            <>
                <label htmlFor="ehr-support"><h2>EHR Support</h2></label>
                <p>Choose the SMART compliant EHR systems where you’ve tested the
                app. If the app is also listed in the EHR vendor’s app store,
                include a direct link to the listing.</p>
                <fieldset className="checkbox-rows">
                { knownEHRs.map(item => {
                    const appEhr = appEHRs.find(x => x.ehr_id === item.id);
                    return (
                        <div key={item.slug} className="checkbox-wrapper">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={ !!appEhr }
                                    onChange={e => {
                                        if (e.target.checked) {
                                            onChange([
                                                ...appEHRs,
                                                {
                                                    ehr_id: +item.id,
                                                    url: this.urls[item.id + ""] || ""
                                                }
                                            ]);
                                        } else {
                                            onChange(appEHRs.filter(x => x.ehr_id !== item.id));
                                        }
                                    }}
                                /> { item.name }
                            </label>
                            <input
                                type="url"
                                data-ehr-id={ item.id } // needed for testing
                                disabled={ !appEhr }
                                placeholder={ item.url_pattern }
                                value={ appEhr ?
                                    appEhr.url || this.urls[item.id + ""] || "" :
                                    this.urls[item.id + ""] || ""
                                }
                                onChange={ e => {
                                    this.urls[item.id + ""] = e.target.value;
                                    if (appEhr) {
                                        appEhr.url = e.target.value;
                                        onChange(appEHRs);
                                    }
                                }}
                            />
                        </div>
                    );
                })}
                </fieldset>
            </>
        )
    }
}
